var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('v-card-actions',{staticClass:"d-flex justify-center align-center pa-0 loading-fixed",style:(_vm.styleObject)},[_c('div',{style:({ width: `${_vm.size}px`, height: `${_vm.size}px` })},[_c('lottie',{attrs:{"options":_vm.lottieOptions,"height":_vm.size,"width":_vm.size}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }